import {
  faIntercom,
  faLinkedin,
  faInstagram,
  faDiscord,
  faFacebookF,
  faYelp,
  faPinterest,
  faTiktok,
  faTwitter,
  faYoutube,
  faGoogle,
} from "@fortawesome/free-brands-svg-icons";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";
import { SocialIcon } from "~/entities/templateEntities";

export const getSocialIcon = (icon: SocialIcon) => {
  switch (icon) {
    case SocialIcon.Instagram:
      return faInstagram;
    case SocialIcon.Facebook:
      return faFacebookF;
    case SocialIcon.Twitter:
      return faTwitter;
    case SocialIcon.Pinterest:
      return faPinterest;
    case SocialIcon.Tiktok:
      return faTiktok;
    case SocialIcon.Youtube:
      return faYoutube;
    case SocialIcon.Yelp:
      return faYelp;
    case SocialIcon.Google:
      return faGoogle;
    case SocialIcon.Discord:
      return faDiscord;
    case SocialIcon.Linkedin:
      return faLinkedin;
    case SocialIcon.Intercom:
      return faIntercom;
    case SocialIcon.Generic:
      return faGlobe;
  }
};
